/**
 * Copyright 2023 SweetCode. All rights reserved.
 *
 * Load GA4 premium event listeners
 * */

// view_item_list event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item_list
jQuery(document).on("wpmViewItemList", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "view_item_list", {
				send_to       : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				items         : [wpm.ga4GetFullProductItemData(product)],
				item_list_name: wpmDataLayer.shop.list_name, // doesn't make sense on mini_cart
				item_list_id  : wpmDataLayer.shop.list_id, // doesn't make sense on mini_cart
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// select_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#select_item
jQuery(document).on("wpmSelectItem", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "select_item", {
				send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				items  : [wpm.ga4GetFullProductItemData(product)],
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// add_to_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_cart
jQuery(document).on("wpmAddToCart", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "add_to_cart", {
				send_to : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				currency: wpmDataLayer.shop.currency,
				// value: 0,
				items: [wpm.ga4GetFullProductItemData(product)],
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// view_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item
jQuery(document).on("wpmViewItem", (event, product = null) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		let data = {
			send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
		}

		if (product) {
			data.currency = wpmDataLayer.shop.currency
			// data.value = 0
			data.items    = [wpm.ga4GetFullProductItemData(product)]
		}

		wpm.gtagLoaded().then(() => {
			gtag("event", "view_item", data)
		})
	} catch (e) {
		console.error(e)
	}
})

// add_to_wishlist event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_wishlist
jQuery(document).on("wpmAddToWishlist", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "add_to_wishlist", {
				send_to : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				currency: wpmDataLayer.shop.currency,
				// value: 0,
				items: [wpm.ga4GetFullProductItemData(product)],
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// remove_from_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#remove_from_cart
jQuery(document).on("wpmRemoveFromCart", (event, product) => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "remove_from_cart", {
				send_to : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				currency: wpmDataLayer.shop.currency,
				// value: 0,
				items: [wpm.ga4GetFullProductItemData(product)],
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// begin_checkout event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#begin_checkout
jQuery(document).on("wpmBeginCheckout", () => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		wpm.gtagLoaded().then(() => {
			gtag("event", "begin_checkout", {
				send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				// coupon: "",
				currency: wpmDataLayer.shop.currency,
				// value: 0,
				items: wpm.getCartItemsGa4(),
			})
		})
	} catch (e) {
		console.error(e)
	}
})

// view_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_cart
jQuery(document).on("wpmViewCart", () => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		if (jQuery.isEmptyObject(wpmDataLayer.cart)) return

		let products  = []
		let cartValue = null

		Object.values(wpmDataLayer.cart).forEach(product => {
			products.push(wpm.ga4GetFullProductItemData(product))
			cartValue = cartValue + product.quantity * product.price
		})

		wpm.gtagLoaded().then(() => {
			gtag("event", "view_cart", {
				send_to : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				currency: wpmDataLayer.shop.currency,
				value   : cartValue.toFixed(2),
				items   : products,
			})
		})
	} catch (e) {
		console.error(e)
	}
})


// view search event
jQuery(document).on("pmwEvent:Search", () => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return

		let products = []

		Object.values(wpmDataLayer.products).forEach(product => {
			products.push(wpm.ga4GetFullProductItemData(product))
		})

		wpm.gtagLoaded().then(() => {
			gtag("event", "view_search_results", {
				send_to    : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
				search_term: wpm.getSearchTermFromUrl(),
				items      : products,
			})

		})


	} catch (e) {
		console.error(e)
	}
})

// user log in event
jQuery(document).on("wpmLogin", () => {

	try {
		if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
		if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
		if (!wpm.googleConfigConditionsMet("analytics")) return


		wpm.gtagLoaded().then(() => {
			gtag("event", "login", {
				send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
			})
		})
	} catch (e) {
		console.error(e)
	}
})


/**
 * Scroll tracking event
 */

jQuery(document).on("pmwScrollDepth", (event, scrollEvent) => {

	if (!wpmDataLayer?.pixels?.google?.analytics?.eec) return
	if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return
	if (!wpm.googleConfigConditionsMet("analytics")) return

	wpm.gtagLoaded().then(() => {
		gtag("event", "scroll", {
			send_to: wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
			value  : scrollEvent.threshold,
		})
	})
})

/**
 * Attach an event listener to all links that contain tel: links
 */
jQuery(document).on("click", "a[href^='tel:']", (event) => {

	// Get the phone number from the link
	let phoneNumber = event.target.href.replace("tel:", "")

	// Trim the phone number and remove all whitespaces
	phoneNumber = phoneNumber.replace(/\s/g, "")

	wpm.gtagLoaded().then(() => {
		gtag("event", "phone_number_click", {
			send_to             : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
			clicked_phone_number: phoneNumber,
		})
	})
})

/**
 * Attach an event listener to all links that contain mailto: links
 */
jQuery(document).on("click", "a[href^='mailto:']", event => {

	console.log("email click")
	console.log("email address: " + wpm.getEmailFromTarget(event.target))
	console.log("event.target: ", event.target)

	wpm.gtagLoaded().then(() => {
		gtag("event", "email_click", {
			send_to      : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
			clicked_email: wpm.getEmailFromTarget(event.target),
		})
	})
})

// Track load time in GA4 in seconds
// https://www.lovesdata.com/blog/page-load-google-analytics
jQuery(window).on("load", () => {

	if (!wpmDataLayer?.pixels?.google?.analytics?.ga4?.page_load_time_tracking) return

	let timeToLoad = (performance.now() / 1000).toFixed(2)

	// console.log("Time to load: " + timeToLoad + " seconds");

	wpm.gtagLoaded().then(() => {
		gtag("event", "page_load_time", {
			send_to               : wpmDataLayer.pixels.google.analytics.ga4.measurement_id,
			page_load_time_seconds: timeToLoad,
		})
	})
})
